module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-40_a8466531ce29e5b6d9d694a86860fde4.png";